import debounce from '@runway/util-debounce';
import { show, hide } from '@runway/util-dom';
import FormCustomEnrollPersonal from '../form-custom-enroll-personal/form-custom-enroll-personal';
import {
    validateDateOfBirth,
    validateEmailAddress,
    validatePriviumNumber
} from '../../utils/member-enrollment';

export const name = 'partner-enrollment-personal';

export default class PartnerEnrollmentPersonal extends FormCustomEnrollPersonal {
    get name() {
        return name;
    }

    constructor(node) {
        super(node);

        this.existingMemberDetails = this.node.querySelectorAll('.existing-privium-member-details');
        this.newMemberDetails = this.node.querySelectorAll('.new-privium-member-details');
        this.membershipStatusSelector = '[name="partner_enrollment_personal_details[existingMember]"]';
        this.priviumNumberSelector = '#partner_enrollment_personal_details_priviumNumber';
        this.emailSelector = '#partner_enrollment_personal_details_email';
        this.dateOfBirthSelector = `#partner_enrollment_personal_details_dateOfBirth_year,
            #partner_enrollment_personal_details_dateOfBirth_month,
            #partner_enrollment_personal_details_dateOfBirth_day`;
        this.priviumNumberNotification = this.node.querySelector('.rw-notification-message--privium-number');
        this.dobNotification = this.node.querySelector('.rw-notification-message--dob-new-member');
        this.emailInfoNotification = this.node.querySelector('.rw-notification-message--email-info');
        this.emailErrorNotification = this.node.querySelector('.rw-notification-message--email-error');
        this.errorMessages = this.node.querySelectorAll('.notification-message--warning');

        this.dobComponentInstance = window.SHG
            .retrieveInstanceFromNode(this.node.querySelector('.rw-input-birthdate'));

        this.initialise();
    }

    initialise() {
        const numberCheckHandler = debounce(event => this.validatePriviumNumber(event), 0);
        const dateOfBirthCheckHandler = debounce(event => this.validateDateOfBirth(event), 0);
        const emailCheckHandler = debounce(event => this.validateEmail(event), 0);
        const phoneNumberSelector = `[name*="partner_enrollment_personal_details[phoneNumber][personal]"],
            [name*="partner_enrollment_personal_details[phoneNumber][business]"]`;
        const debouncedPhoneInputBlurHandler = debounce(e => this.handlePhoneNumberInputBlur(e), 0);

        this.subscribe(`dom:${this.membershipStatusSelector}:change`, event => this.onStatusChange(event));
        this.subscribe(`dom:${this.priviumNumberSelector}:blur`, numberCheckHandler);
        this.subscribe(`dom:${this.emailSelector}:blur`, emailCheckHandler);
        this.subscribe(`dom:${this.dateOfBirthSelector}:blur`, dateOfBirthCheckHandler);
        this.subscribe(`dom:${phoneNumberSelector}:input`, event => this.handlePhoneNumberInputChange(event));
        this.subscribe(`dom:${phoneNumberSelector}:blur`, debouncedPhoneInputBlurHandler);

        this.setExistingMember(this.isExistingMember());
    }

    isExistingMember() {
        const element = this.node.querySelector('#partner_enrollment_personal_details_existingMember_0');

        return element.checked;
    }

    submit() {
        this.node.submit();
    }

    onStatusChange(event) {
        this.toggleExistingMember(event.target.value === '1');
    }

    toggleExistingMember(isExistingMember) {
        [...this.errorMessages].forEach(hide);
        this.cleanErrors();
        this.dobComponentInstance.cleanError();
        this.setExistingMember(isExistingMember);
    }

    setExistingMember(isExistingMember) {
        if (isExistingMember) {
            Array.from(this.existingMemberDetails).forEach(show);
            Array.from(this.newMemberDetails).forEach(hide);
        } else {
            Array.from(this.existingMemberDetails).forEach(hide);
            Array.from(this.newMemberDetails).forEach(show);
        }
    }

    async validatePriviumNumber(event) {
        event.stopPropagation();

        const number = event.target.value;

        if (number && event.target.checkValidity()) {
            try {
                await validatePriviumNumber(number);

                hide(this.priviumNumberNotification);
            } catch (error) {
                show(this.priviumNumberNotification);
            }
        }
    }

    async validateEmail(event) {
        event.stopPropagation();

        const emailAddress = event.target.value;

        if (emailAddress) {
            try {
                await validateEmailAddress(emailAddress);

                hide(this.emailInfoNotification);
                show(this.emailErrorNotification);
            } catch (error) {
                show(this.emailInfoNotification);
                hide(this.emailErrorNotification);
            }
        }
    }

    async validateDateOfBirth(event) {
        event.stopPropagation();

        if (this.isExistingMember()) {
            return Promise.resolve();
        }

        if (this.dobComponentInstance.isValid()) {
            try {
                const date = this.getDate(this.dobComponentInstance.getElements());

                await validateDateOfBirth(date);

                hide(this.dobNotification);
            } catch (error) {
                show(this.dobNotification);
            }
        }

        return Promise.resolve();
    }

    getDate(elements) {
        const date = {};

        elements.forEach(element => {
            const firstIndex = element.name.lastIndexOf('[') + 1;
            const lastIndex = element.name.lastIndexOf(']');
            const elementName = element.name.substring(firstIndex, lastIndex);

            date[elementName] = element.value;
        });

        return `${date.year}-${date.month}-${date.day}`;
    }
}
